// import React from "react";
import {
    Box,
    Divider,
    Fade,
    IconButton,
    Menu,
    MenuItem,
    Stack,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import AppealAvatar from "../../components/AppealAvatar";
import { int2ip } from "../../utils/formatIpAddress";
import appealsStore from '../../store/appealsStore';
import useResponsive from "../../hooks/useResponsive";
import truncateString from "../../utils/trancate";

import AppealEdit from "../../components/AppealEdit/AppealEdit"

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
// import { isDisabled } from "@testing-library/user-event/dist/utils";
// import { CaretDown, MagnifyingGlass, Phone, VideoCamera } from "phosphor-react";
// import { faker } from "@faker-js/faker";
// import useResponsive from "../../hooks/useResponsive";
// import { ToggleSidebar } from "../../redux/slices/app";
// import { useDispatch, useSelector } from "react-redux";
// import { StartAudioCall } from "../../redux/slices/audioCall";
// import { StartVideoCall } from "../../redux/slices/videoCall";

const ChatHeader = ({ handleOpenSearch, appeal }) => {
    // const dispatch = useDispatch();
    const isMobile = useResponsive("between", "md", "xs", "sm");
    // const isDesktop = useResponsive("up", "md");
    const theme = useTheme();
            
    // const {current_conversation} = useSelector((state) => state.conversation.direct_chat);

    const [openAppealEdit, setOpenAppealEdit] = useState(false);
    const [conversationMenuAnchorEl, setConversationMenuAnchorEl] = useState(null);
    const openConversationMenu = Boolean(conversationMenuAnchorEl);

    const provider = appealsStore.getProviders().find(provider => provider.id === appeal.provider_id)
    const group = appealsStore.getAppealGroup().find(group => group.id === appeal.group_id)

    const name = () => {
        switch(appeal.source_type) {
            case 'user':
                return appeal.crm_object.login ? appeal.crm_object.login : appeal.source
            case 'host': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            case 'network': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            case 'system_user': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            default: 
                return appeal.source
        }
    }

    const handleClickBack = () => {
        appealsStore.setAppeal({})
    }

    const handleClickConversationMenu = (event) => {
        setConversationMenuAnchorEl(event.currentTarget);
    };

    const handleCloseConversationMenu = () => {
        setConversationMenuAnchorEl(null);
    };

    const handleCloseAppealEdit = () => {
        setConversationMenuAnchorEl(null);
        setOpenAppealEdit(false);
    }

    const handleOpenAppealEdit = () => {
        setConversationMenuAnchorEl(null);
        setOpenAppealEdit(true);
    }

    return (
        <>
            <Box
                p={2}
                width={"100%"}
                sx={{
                    backgroundColor:
                        theme.palette.mode === "light"
                            ? "#F8FAFF"
                            : theme.palette.background,
                    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                }}
            >
                {/* MODAL Appeal edit */}
                <AppealEdit
                    appeal={appeal}
                    open={openAppealEdit}
                    handleClose={handleCloseAppealEdit}
                >
                </AppealEdit>

                <Stack
                    // alignItems={"center"}
                    direction={"row"}
                    sx={{ width: "100%", height: "100%" }}
                    justifyContent="space-between"
                >
                    {/* Back button and Header*/}
                    <Stack direction={"row"} spacing={1}>

                        {/* Back button */}
                        <Stack direction={"row"} spacing={2}>
                            <IconButton
                                onClick={handleClickBack}
                            >
                                <ArrowBackIosIcon /><Typography>Back</Typography>
                            </IconButton>
                            <Divider orientation="vertical" flexItem />
                        </Stack>

                        {/* Header */}
                        <AppealAvatar
                            type="header"
                            provider={provider}
                            group={group}
                            appeal={appeal}
                        />
                        {/* <Stack
                            // onClick={() => {
                            //     dispatch(ToggleSidebar());
                            // }}
                            spacing={1}
                            direction="row"
                        >
                            <AppealAvatar type={appeal.source_type} isOpen={appeal.is_open}/>
                            <Stack spacing={0.1}>
                                <Typography variant="subtitle2">{truncateString(provider.name + " - " + group.name, 50)}</Typography>
                                <Typography variant="caption">{name()}</Typography>   
                            </Stack>
                        </Stack> */}
                    </Stack>

                     {/* Menu and Search button */}
                    <Stack direction={"row"} spacing={2}>
                        <IconButton
                            id="conversation-positioned-button"
                            aria-controls={
                                openConversationMenu
                                ? "conversation-positioned-menu"
                                : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={openConversationMenu ? "true" : undefined}
                            onClick={handleClickConversationMenu}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            MenuListProps={{
                                "aria-labelledby": "fade-button",
                            }}
                            TransitionComponent={Fade}
                            id="conversation-positioned-menu"
                            aria-labelledby="conversation-positioned-button"
                            anchorEl={conversationMenuAnchorEl}
                            open={openConversationMenu}
                            onClose={handleCloseConversationMenu}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            >
                            <Box p={1}>
                                <Stack spacing={1}>
                                    <MenuItem onClick={handleOpenAppealEdit}>
                                        <Stack
                                            sx={{ minWidth: 100 }}
                                            direction="row"
                                            alignItems={"center"}
                                            justifyContent="space-between"
                                        >
                                            <span>Edit appeal</span>
                                        </Stack>{" "}
                                    </MenuItem>
                                </Stack>
                            </Box>
                        </Menu>
                        <Divider orientation="vertical" flexItem />
                        <IconButton onClick={handleOpenSearch}>
                            <SearchIcon />
                        </IconButton>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

export default ChatHeader;